import React from 'react'
import { useI18n } from '../state/I18nContext'

const News: React.FC = () => {
  const { t } = useI18n()
  const n = t.news
  return (
    <section className="max-w-6xl mx-auto px-4 py-10">
      <div className="mb-8">
        <h1 className="text-3xl font-bold">{n.title}</h1>
        <p className="text-neutral-600">{n.description}</p>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {n.posts.map(post => (
          <article key={post.id} className="border border-neutral-200 rounded-lg p-4">
            <div className="text-xs text-white bg-amber-600 inline-block px-2 py-0.5 rounded mb-2">
              {post.badge}
            </div>
            <h3 className="text-lg font-semibold mb-1">{post.title}</h3>
            <p className="text-sm text-neutral-600 mb-2">{post.excerpt}</p>
            <time className="text-xs text-neutral-500">{post.date}</time>
            <div className="mt-3">
              <button className="text-amber-700 hover:underline text-sm">{n.button}</button>
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}

export default News
